<div>
  <router-outlet>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
      <p class="loader">{{'UI_LOADING' | translate}}...</p>
    </ngx-spinner>
  </router-outlet>

  <p-toast></p-toast>

  <p-dialog
    [styleClass]="'1'" header="Version Update" [closeOnEscape]="false" [modal]="true" [(visible)]="display" [closable]="false" [style]="{width: '300px'}">
    <p>{{'UI_THERE_IS_A_NEWER_VERSION_OF_THIS_APP_AVAILABLE' | translate}}</p>
    <ng-template pTemplate="footer">
      <button type="button" (click)="updateVersion()"  class="btn btn-primary"><i class="pi pi-check"></i> {{'UI_UPDATE_NOW' | translate}}</button>
    </ng-template>
  </p-dialog>

  <p-drawer [fullScreen]="true" [position]="'top'" [(visible)]="isErrorListDisplay">
    <div class="alert alert-danger">
      <h6 class="alert-heading">{{'UI_PLEASE_FIX_THE_ERRORS_BELOW' | translate}}</h6>
      <ul style="margin: 0.7rem 0">
        @for (subErrs of errorList; track subErrs; let eI = $index) {
          @for (errName of subErrs; track errName; let eJ = $index) {
            <li>
              {{errName}}
            </li>
          }
        }
      </ul>
    </div>
  </p-drawer>

  <p-dialog
    header="Information"
    position="top"
    [(visible)]="isStickyMsgDisplay"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
    <p innerHtml="{{stickyMsg}}"></p>
  </p-dialog>

</div>
